import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { curry, pipe, safe, map, chain, not, option } from "crocks";
import { isNumeric } from "@s-e/frontend/pred";

dayjs.extend(isBetween);

export const leftDays = (valid_until, valid_from = new Date()) => {
  const dateJS = dayjs(valid_until);
  return dateJS.diff(valid_from, "day");
};

export const orderAmount = (
  monthly_price,
  daily_price,
  valid_until,
  valid_from = new Date(),
) => {
  const dateJS = dayjs(valid_until);
  let days = dateJS.diff(dayjs(valid_from), "day");
  let months = dateJS.diff(dayjs(valid_from), "month");
  if (days === 0) {
    return monthly_price?.toFixed(2);
  }
  if (months >= 1) {
    return monthly_price?.toFixed(2);
  }
  return (
    days * daily_price > monthly_price ? monthly_price : days * daily_price
  ).toFixed(2);
};

export const calcIsDaily = (valid_until, valid_from = new Date()) => {
  return dayjs(valid_until).diff(dayjs(valid_from), "month") === 0;
};

export const orderPrice = (
  monthly_price,
  daily_price,
  valid_until,
  valid_from = new Date(),
) => {
  return (
    orderAmount(monthly_price, daily_price, valid_until, valid_from) + " €"
  );
};

export const validPhone = (phone) => {
  let regex = /^\+[1-9]\d{1,14}$/;
  return !!(phone && phone.match(regex));
};

export const expireDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);

export const DAILY = "DAILY";
export const HOURLY = "HOURLY";

export const GATE_STATUSES = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const isAccessHours = () => {
  const currentTime = dayjs();
  const openTime = dayjs().hour(6).minute(0).second(0);
  const closeTime = dayjs().hour(22).minute(0).second(0);
  const isWithinOperatingHours = currentTime.isBetween(
    openTime,
    closeTime,
    null,
    "[]",
  );

  const currentDay = currentTime.day();
  const isWeekday = currentDay >= 1 && currentDay <= 5;

  return isWithinOperatingHours && isWeekday;
};

export const forceNum = curry((defaultValue, value) =>
  pipe(
    safe(isNumeric),
    map(Number),
    chain(safe(not(isNaN))),
    option(defaultValue),
  )(value),
);

export const numberOrZero = forceNum(0);

/**
 * @type {<T extends string>(...names: T[]) => { [K in T]: K }}
 *
 * @example
 * const C = mkenum("A", "B", "C");
 * // type: { A: "A"; B: "B"; C: "C" }
 *
 * @example
 * const arr = ["X", "Y"] as const;
 * const E = mkenum(...arr);
 * // type: { X: "X"; Y: "Y" }
 */
export const mkenum = (...names) =>
  names.reduce(
    (carry, item) => ({
      ...carry,
      [item]: item,
    }),
    {},
  );
